import React from 'react'
import { ToastContainer } from 'react-toastify'
import { useTheme } from '../contexts/ThemeContext'

const ToastContainerThemed = () => {
  const { isDark } = useTheme()

  return (
    <ToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={isDark ? 'dark' : 'light'}
      className="mobile-toast-container"
      toastClassName="mobile-toast"
      bodyClassName="mobile-toast-body"
      style={{
        fontSize: '14px',
        maxWidth: '90vw',
        margin: '0 auto',
      }}
    />
  )
}

export default ToastContainerThemed
